import { Dialog, IconButton, styled } from "@mui/material";
import { ZoomIn, ZoomOut, Close } from "@mui/icons-material";
import { useState } from "react";

const PreviewContainer = styled("div")({
  position: "relative",
  width: "100%",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.9)",
});

const ZoomControls = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: 20,
  left: "50%",
  transform: "translateX(-50%)",
  display: "flex",
  gap: theme.spacing(2),
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 8,
  right: 8,
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.common.white,
  zIndex: 3,
  padding: theme.spacing(1),
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
  },
}));

const ImagePreviewModal = ({ open, onClose, imageUrl }) => {
  const [scale, setScale] = useState(1);

  const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.5, 3));
  const handleZoomOut = () => setScale((prev) => Math.max(prev - 0.5, 0.5));

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} fullScreen>
      <PreviewContainer>
        <CloseButton onClick={onClose}>
          <Close />
        </CloseButton>
        <img
          src={imageUrl}
          alt="Preview"
          crossOrigin="use-credentials"
          style={{
            maxWidth: "90%",
            maxHeight: "90vh",
            objectFit: "contain",
            transform: `scale(${scale})`,
            transition: "transform 0.2s ease-in-out",
          }}
        />
        <ZoomControls>
          <IconButton onClick={handleZoomOut} color="primary">
            <ZoomOut />
          </IconButton>
          <IconButton onClick={handleZoomIn} color="primary">
            <ZoomIn />
          </IconButton>
        </ZoomControls>
      </PreviewContainer>
    </Dialog>
  );
};

export default ImagePreviewModal;
